/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_01_LabelInputs */

const en_landing_section_01_label = /** @type {(inputs: Landing_Section_01_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerful platform`)
};

const de_landing_section_01_label = /** @type {(inputs: Landing_Section_01_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistungsstarke Plattform`)
};

const fr_landing_section_01_label = /** @type {(inputs: Landing_Section_01_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerful platform`)
};

const es_landing_section_01_label = /** @type {(inputs: Landing_Section_01_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerful platform`)
};

const it_landing_section_01_label = /** @type {(inputs: Landing_Section_01_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerful platform`)
};

const nl_landing_section_01_label = /** @type {(inputs: Landing_Section_01_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerful platform`)
};

const pl_landing_section_01_label = /** @type {(inputs: Landing_Section_01_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerful platform`)
};

const fi_landing_section_01_label = /** @type {(inputs: Landing_Section_01_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerful platform`)
};

const da_landing_section_01_label = /** @type {(inputs: Landing_Section_01_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerful platform`)
};

const sv_landing_section_01_label = /** @type {(inputs: Landing_Section_01_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powerful platform`)
};

/**
* | output |
* | --- |
* | "Powerful platform" |
*
* @param {Landing_Section_01_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_01_label = /** @type {((inputs?: Landing_Section_01_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_01_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_01_label(inputs)
	if (locale === "fr") return fr_landing_section_01_label(inputs)
	if (locale === "es") return es_landing_section_01_label(inputs)
	if (locale === "it") return it_landing_section_01_label(inputs)
	if (locale === "nl") return nl_landing_section_01_label(inputs)
	if (locale === "pl") return pl_landing_section_01_label(inputs)
	if (locale === "fi") return fi_landing_section_01_label(inputs)
	if (locale === "da") return da_landing_section_01_label(inputs)
	if (locale === "sv") return sv_landing_section_01_label(inputs)
	return en_landing_section_01_label(inputs)
});